import { render } from "./MidTab.vue?vue&type=template&id=d3601c70"
import script from "./MidTab.vue?vue&type=script&lang=js"
export * from "./MidTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__